import React from 'react';
import {
  Briefcase,
  TrendingUp,
  Shield,
  Cloud,
  Network,
  Brain,
  Code,
  Layers,
  Server
} from 'lucide-react';

const CareerOutcomes = () => {
  const careers = [
    // Cybersecurity
    {
      icon: Shield,
      title: 'SOC Analyst',
      description: 'Monitor, detect, and respond to security threats'
    },
    {
      icon: Shield,
      title: 'Cybersecurity Analyst',
      description: 'Protect systems, networks, and data from cyber attacks'
    },
    {
      icon: Shield,
      title: 'Penetration Tester',
      description: 'Identify and exploit vulnerabilities to improve security'
    },

    // Cloud & Networking
    {
      icon: Cloud,
      title: 'Cloud / Azure Administrator',
      description: 'Manage and secure cloud infrastructure and services'
    },
    {
      icon: Network,
      title: 'Network Engineer',
      description: 'Design, configure, and maintain enterprise networks'
    },

    // AI / ML
    {
      icon: Brain,
      title: 'AI / ML Associate',
      description: 'Build intelligent systems using machine learning models'
    },

    // GRC
    {
      icon: Briefcase,
      title: 'GRC Analyst',
      description: 'Ensure governance, risk management, and compliance'
    },

    // Web & Software Development
    {
      icon: Code,
      title: 'Frontend Developer',
      description: 'Build responsive and interactive user interfaces'
    },
    {
      icon: Server,
      title: 'Backend Developer',
      description: 'Develop scalable APIs and server-side applications'
    },
    {
      icon: Layers,
      title: 'Full Stack Developer',
      description: 'Work across frontend, backend, and databases'
    }
  ];

  return (
    <section
      id="careers"
      style={{
        background: 'var(--bg-primary)',
        padding: '100px 7.6923%',
        borderTop: '1px solid var(--border-subtle)'
      }}
    >
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              marginBottom: '20px'
            }}
          >
            <TrendingUp size={32} style={{ color: 'var(--brand-primary)' }} />
            <h2 className="display-large">Career Outcomes</h2>
          </div>

          <p
            className="body-large"
            style={{
              color: 'var(--text-secondary)',
              maxWidth: '800px',
              margin: '0 auto'
            }}
          >
            Launch your career in high-demand IT, cybersecurity, cloud, and development roles
          </p>
        </div>

        {/* Career Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px'
          }}
        >
          {careers.map((career, index) => {
            const Icon = career.icon;
            return (
              <div
                key={index}
                className="dark-hover"
                style={{
                  background: 'var(--bg-secondary)',
                  padding: '30px',
                  border: '1px solid var(--border-subtle)',
                  textAlign: 'center',
                  transition: 'all 0.4s ease-in-out'
                }}
              >
                <Icon
                  size={40}
                  style={{
                    color: 'var(--brand-primary)',
                    marginBottom: '16px'
                  }}
                />
                <h3 className="heading-3" style={{ marginBottom: '8px' }}>
                  {career.title}
                </h3>
                <p className="body-small" style={{ color: 'var(--text-muted)' }}>
                  {career.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareerOutcomes;